import React from 'react';

export default function HstreamLogo() {
  return (
    <img style={{width: '100%', height: 'auto', display: 'inline-flex'}} src='/assets/hstream_logo.png' title='hStream'/>
  );
}
